module.exports = __webpack_public_path__ + "static/w-aulia-14451ce53294c950c05862f02ccc2c43.jpg";